import { CalendarOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import SharedWelcomeBar from "../../../../components/WelcomeBar";
import {
  DatePopupWrap,
  DateRangePill,
} from "../../../../components/WelcomeBar/style";
import { ModuleLabel, ModuleSelectPill, YearPickerPill } from "../../style";
import type { AnalyticsModule, DateRange } from "../../types";

dayjs.extend(customParseFormat);

const MODULE_OPTIONS = [
  { value: "registration", label: "Registration" },
  { value: "appointments", label: "Appointments" },
];

interface WelcomeBarProps {
  name: string;
  module: AnalyticsModule;
  onModuleChange: (value: AnalyticsModule) => void;
  dateRange: DateRange;
  onDateRangeChange: (value: DateRange) => void;
  year: Dayjs | null;
  onYearChange: (value: Dayjs | null) => void;
}

export default function WelcomeBar({
  name,
  module,
  onModuleChange,
  dateRange,
  onDateRangeChange,
  year,
  onYearChange,
}: WelcomeBarProps) {
  return (
    <SharedWelcomeBar
      name={name}
      subtitle="Call performance metrics split into successful and unsuccessful graphs."
      controls={
        <>
          <ModuleLabel>Select Analytics module</ModuleLabel>
          <ModuleSelectPill
            value={module}
            onChange={(value) => onModuleChange(value as AnalyticsModule)}
            options={MODULE_OPTIONS}
          />
          <DateRangePill
            value={dateRange}
            onChange={(values) =>
              onDateRangeChange((values as DateRange) ?? null)
            }
            format="DD/MM/YYYY"
            allowClear
            allowEmpty={[true, true]}
            placeholder={["Start date", "End date"]}
            disabledDate={(current: Dayjs) => current.isAfter(dayjs(), "day")}
            panelRender={(panel: React.ReactNode) => (
              <DatePopupWrap>{panel}</DatePopupWrap>
            )}
          />
          <YearPickerPill
            picker="year"
            value={year}
            onChange={(value) => onYearChange((value as Dayjs) ?? null)}
            placeholder="Select Year"
            allowClear
            suffixIcon={<CalendarOutlined />}
            disabledDate={(current: Dayjs) => current.isAfter(dayjs(), "year")}
            panelRender={(panel: React.ReactNode) => (
              <DatePopupWrap>{panel}</DatePopupWrap>
            )}
          />
        </>
      }
    />
  );
}
